import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

const HelpTab = () => {

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Course || {},
  }));

  return (
    <Box display={"flex"} flexDirection={"column"} gap={"16px"}>
      <Typography variant="subtitle" fontWeight={500}>
        {Translation?.HelpRequests}
      </Typography>
      <Typography>
        {Translation?.HelpRequestAppear}
      </Typography>
      <Box
        sx={(theme) => ({
          background: theme.palette.background.default,
          borderRadius: "16px",
          padding: "16px",
        })}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Button variant="outlined" color="secondary">
          {Translation?.ViewRaisedHelpRequest}
        </Button>
      </Box>
    </Box>
  );
};

export default HelpTab;
